export function formatNumberAsThousands(number, decimals = 0) {
  if (!number) {
    return 0.0
  }

  return Number(number)
    .toFixed(decimals)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
